/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popLuckyGift.vue?vue&type=template&id=6fbc8b9d&scoped=true"
import script from "./popLuckyGift.vue?vue&type=script&lang=js"
export * from "./popLuckyGift.vue?vue&type=script&lang=js"
import style0 from "./popLuckyGift.vue?vue&type=style&index=0&id=6fbc8b9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbc8b9d",
  null
  
)

export default component.exports